export default __webpack_public_path__ + "static/media/thebridge-white.36b21d03.svg";